module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-diamond-a7d97600.svg";